import type { GetCourseReviews200Pagination } from './getCourseReviews200Pagination';
import type { GetCourseReviews200ReviewsItem } from './getCourseReviews200ReviewsItem';

export type GetCourseReviews200 = {
  /** 페이지네이션 정보 */
  pagination: GetCourseReviews200Pagination;
  /** 조회된 리뷰 목록 */
  reviews: GetCourseReviews200ReviewsItem[];
};
